import MethodOfContactTypes from 'models/types/MethodOfContactTypes';
import React, { useEffect, useRef, useState } from 'react';

interface Props {
    selected: MethodOfContactTypes;
    updateMethodOfContact: (type: MethodOfContactTypes) => void;
    isDisabled: boolean;
}

const MethodOfContact: React.FC<Props> = ({ selected, updateMethodOfContact, isDisabled }: Props) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Close dropdown when clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="w-full relative" ref={dropdownRef}>
            <div
                className={`w-full rounded-md border ${
                    isDisabled ? 'bg-gray-100' : 'bg-white focus:ring-1 focus:outline-none focus:border-blue-500'
                } ${isExpanded && !isDisabled ? 'border-blue-500 ring-1 ring-blue-500' : ''}`}
            >
                <div
                    className={`w-full cursor-pointer text-lg font-semibold px-2 py-2 flex items-center justify-between ${
                        isDisabled ? 'cursor-not-allowed' : ''
                    }`}
                    onClick={() => !isDisabled && setIsExpanded(!isExpanded)}
                >
                    <span>{methodsOfContact.find((MOC) => MOC.value === selected)?.name || 'Select'}</span>
                    {!isDisabled && (
                        <svg
                            className="w-4 h-4 text-gray-500"
                            aria-hidden="true"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    )}
                </div>
            </div>
            {isExpanded && !isDisabled && (
                <div className="w-full z-20 absolute mt-1 bg-white rounded overflow-hidden shadow-lg border border-gray-200">
                    <ul className="py-1 text-lg text-gray-700">
                        {methodsOfContact.map((methodOfContact) => (
                            <li
                                className={`cursor-pointer ${
                                    methodOfContact.value === selected
                                        ? 'bg-blue-100 text-blue-700'
                                        : 'hover:bg-gray-50'
                                } py-2 px-4 font-semibold`}
                                key={methodOfContact.value}
                                onClick={() => {
                                    updateMethodOfContact(methodOfContact.value);
                                    setIsExpanded(false);
                                }}
                            >
                                {methodOfContact.name}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

const methodsOfContact = [
    {
        name: 'Phone',
        value: MethodOfContactTypes.Phone,
    },
    {
        name: 'SMS',
        value: MethodOfContactTypes.SMS,
    },
    {
        name: 'Email',
        value: MethodOfContactTypes.Email,
    },
];

export default MethodOfContact;
